import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import HELPERS from "../../utils/helper";
import apis from "../../config/apis";
import { colors } from "../../css/colors";
import CONFIG from "../../config";
import { ToastMessage, Toast, toastMsgConfig } from "../../components/toast";
import Error, { ErrorMessageHandling } from "../../components/error";
import ProductDesc from "./productDesc";
import { imageURL } from "../../utils/constants";
import {
  getInstalmentSchedule,
  initiateInstalmentPayment,
} from "./instalmentPayment";
import {
  getPaymentGatewayChecking,
} from "../cart/payment";
import InstalmentSchedule from "../../components/instalmentSchedule";

class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      success: false,
      orders: [],
      show_product_desc: false,
      selected_item: {},
      instalmentSchedules: {},
      instalmentSelections: {},
      instalmentLoading: false,
      paymentLoader: false,
      public_token: "",
      is_oAuth_done: "",
      gatewayDta: {},
    };
  }

  componentDidMount = () => {
    this.getMyOrders();
    getPaymentGatewayChecking(
      this.props,
      () => {},
      this.updateGatewayData
    );
  };

  updateGatewayData = (data) => {
    this.setState({
      public_token: data?.Razorpay?.public_token || data?.public_token,
      is_oAuth_done: data?.Razorpay?.is_oAuth_done || data?.is_oAuth_done,
      gatewayDta: data,
    });
  };

  getMyOrders = async () => {
    const { user_id, student_auth, institute_id } = this.props;
    let headers = {
      headers: {
        "x-prod-user-id": user_id,
        "x-prod-inst-id": institute_id,
        Authorization: student_auth,
      },
    };
    try {
      let res = await HELPERS.ApiCall(
        apis.MY_ORDER,
        {},
        "GET",
        "product",
        headers
      );
      if (res.status == 200 && res.data.status_code == 200) {
        this.setState({
          loader: false,
          orders: res.data.result,
          success: true,
        });
        this.fetchInstalmentSchedules(res.data.result);
      } else {
        this.message("e", res.data.message);
        this.setState({ loader: false, success: false });
      }
    } catch (error) {
      if (error.response && error.response.status == 403) {
        this.props.dispatch({ type: "LOGOUT" });
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        Array.isArray(error.response.data.error) &&
        error.response.data.error.length > 0
      ) {
        this.message("e", error.response.data.error[0].error_message);
      } else {
        this.message("e", ErrorMessageHandling(error));
      }
      this.setState({ loader: false, success: false });
    }
  };

  fetchInstalmentSchedules = async (orders) => {
    const { user_id, student_auth, institute_id } = this.props;
    const instalmentOrders = orders.filter(
      (item) => item.is_instalment_product === "Y"
    );
    if (instalmentOrders.length === 0) {
      return;
    }

    this.setState({ instalmentLoading: true });
    const schedules = {};

    await Promise.all(
      instalmentOrders.map((item) =>
        getInstalmentSchedule({
          productId: item.id,
          institute_id,
          user_id,
          student_auth,
        })
          .then((result) => {
            // console.log("[MyOrders] Schedule result for", item.id, ":", result);
            schedules[item.id] = result.user_instalments || result.product_instalments || result.instalments || result || [];
            // console.log("[MyOrders] Parsed schedule for", item.id, ":", schedules[item.id]);
          })
          .catch((err) => {
            console.log("[MyOrders] Failed to fetch schedule for", item.id, ":", err);
          })
      )
    );

    // console.log("[MyOrders] All schedules fetched:", schedules);

    // Initialize selections: first pending instalment pre-selected for each product
    const selections = {};
    Object.keys(schedules).forEach((productId) => {
      const schedule = schedules[productId];
      const firstPendingIdx = schedule.findIndex(
        (inst) => inst.status === 10 || inst.status === 30
      );
      if (firstPendingIdx !== -1) {
        selections[productId] = [firstPendingIdx + 1];
      }
    });

    this.setState({
      instalmentSchedules: schedules,
      instalmentSelections: selections,
      instalmentLoading: false,
    });
  };

  getInstalmentBadge = (productId) => {
    const schedule = this.state.instalmentSchedules[productId];
    if (!schedule || schedule.length === 0) return null;

    const paid = schedule.filter((inst) => inst.status === 20).length;
    const total = schedule.length;
    const hasOverdue = schedule.some((inst) => inst.status === 30);

    let badgeColor = "#ff9800"; // orange for pending
    if (paid === total) badgeColor = "#4CAF50"; // green if all paid
    if (hasOverdue) badgeColor = "#f44336"; // red if overdue

    return (
      <span
        style={{
          backgroundColor: badgeColor,
          color: "#fff",
          padding: "2px 8px",
          borderRadius: 4,
          fontSize: 10,
          fontWeight: 600,
          marginLeft: 6,
        }}
      >
        {paid}/{total} Paid
      </span>
    );
  };

  getNextPendingInstalment = (productId) => {
    const schedule = this.state.instalmentSchedules[productId];
    if (!schedule) return null;
    return schedule.find((inst) => inst.status === 10 || inst.status === 30);
  };

  handleInstalmentSelectionChange = (productId, selectedInstalments) => {
    this.setState((prev) => ({
      instalmentSelections: {
        ...prev.instalmentSelections,
        [productId]: selectedInstalments,
      },
    }));
  };

  handlePayInstalment = async (item, selectedInstalments, totalAmount) => {
    const { user_id, student_auth, institute_id, user_info, user_type } =
      this.props;
    const { public_token, is_oAuth_done, gatewayDta } = this.state;

    if (!selectedInstalments || selectedInstalments.length === 0) {
      this.message("e", "Please select at least one installment to pay.");
      return;
    }

    this.setState({ paymentLoader: true });

    try {
      await initiateInstalmentPayment({
        productId: item.id,
        selectedInstalments,
        totalAmount,
        props: this.props,
        gatewayData: gatewayDta,
        public_token,
        is_oAuth_done,
        c_symbol: item.c_code || "INR",
        country_id:
          item.country_details?.country_id || this.props.country_details?.country_id || null,
        onSuccess: () => {
          this.setState({ paymentLoader: false });
          this.getMyOrders();
        },
        onFailure: () => {
          this.setState({ paymentLoader: false });
        },
        setLoader: (val) => this.setState({ paymentLoader: val }),
        message: this.message,
      });
    } catch (error) {
      this.setState({ paymentLoader: false });
      const errMsg =
        error?.response?.data?.message || error.message || "Failed to initiate payment";
      this.message("e", errMsg);
    }
  };

  message = (type, message) => {
    Toast(message, toastMsgConfig(type));
  };

  render() {
    const {
      loader,
      orders,
      success,
      show_product_desc,
      selected_item,
      instalmentSchedules,
      instalmentSelections,
      paymentLoader,
    } = this.state;
    return (
      <>
        <ToastMessage />
        {(loader || paymentLoader) && (
          <div className="content">
            <div className="dashboardLoader"></div>
          </div>
        )}
        {!loader && success && orders.length > 0 && (
          <div className="content bgimg2">
            <div
              className="portalMainContent"
              style={{ paddingTop: 40, width: "90%" }}
            >
              <h2>My Orders</h2>
              <div className="listContainer">
                {orders.map((item, i) => {
                  const isInstalment = item.is_instalment_product === "Y";
                  const nextPending = isInstalment
                    ? this.getNextPendingInstalment(item.id)
                    : null;

                  return (
                    <div key={i} className="productDiv">
                      <img
                        src={
                          item.photo_url && item.photo_url !== ""
                            ? item.photo_url
                            : imageURL
                        }
                        style={{ height: 150, width: "100%" }}
                        alt="Product thumbnail"
                      />
                      <div className="productContent" style={{ minHeight: 120 }}>
                        <h5 style={{ color: "#bb65f8" }}>
                          {item.title}
                          {isInstalment && this.getInstalmentBadge(item.id)}
                        </h5>
                        <div className="productDates">
                          <div>
                            <h6 style={{ color: "gray" }}>Purchased Date</h6>
                            <h5>
                              {new Date(
                                item.enrolled_date
                              ).toLocaleDateString()}
                            </h5>
                          </div>
                          <div>
                            <h6 style={{ color: "gray" }}>Expired Date</h6>
                            <h5>
                              {new Date(item.expire_on).toLocaleDateString()}
                            </h5>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h6 style={{ color: colors.JADE }}>
                            {item.is_paid == "N"
                              ? "Free"
                              : item.price +
                                " " +
                                (item.country_details && item.c_code
                                  ? item.c_code
                                  : "")}
                          </h6>
                          <div style={{ display: "flex", gap: 6 }}>
                            <button
                              style={{
                                borderColor: "#bb65f8",
                                color: "#bb65f8",
                              }}
                              onClick={() => {
                                this.setState({
                                  selected_item: item,
                                  show_product_desc: true,
                                });
                              }}
                            >
                              View <i className="fa fa-angle-right"></i>
                            </button>
                          </div>
                        </div>

                        {isInstalment && nextPending && instalmentSchedules[item.id] && (
                          <div style={{ marginTop: 8 }}>
                            <div
                              style={{
                                cursor: "pointer",
                                fontSize: 12,
                                color: "#1976d2",
                                fontWeight: 600,
                                marginBottom: 4,
                              }}
                              onClick={() => {
                                const key = `scheduleExpanded_${item.id}`;
                                this.setState({ [key]: !this.state[key] });
                              }}
                            >
                              <i
                                className={
                                  this.state[`scheduleExpanded_${item.id}`]
                                    ? "fa fa-chevron-up"
                                    : "fa fa-chevron-down"
                                }
                                style={{ marginRight: 4 }}
                              ></i>
                              Pay Installments
                            </div>
                            {this.state[`scheduleExpanded_${item.id}`] && (
                              <InstalmentSchedule
                                instalments={instalmentSchedules[item.id]}
                                purchased={true}
                                selectable={true}
                                selectedInstalments={instalmentSelections[item.id] || []}
                                onSelectionChange={(selected) =>
                                  this.handleInstalmentSelectionChange(item.id, selected)
                                }
                                onPayNext={(selectedNums, selectedTotal) =>
                                  this.handlePayInstalment(item, selectedNums, selectedTotal)
                                }
                                currencyCode={
                                  item.c_code || ""
                                }
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {!loader && success && orders.length == 0 && (
          <div
            className="myOrderEmptyCart bgimg2"
            style={{ height: window.innerHeight - 40 }}
          >
            <i
              className="fa fa-shopping-bag"
              style={{ fontSize: 60, marginBottom: 20 }}
            ></i>
            <h4>You haven't purchased any product yet!</h4>
          </div>
        )}
        {!loader && !success && (
          <Error onReload={this.getMyOrders} message={""} />
        )}

        {show_product_desc && (
          <ProductDesc
            show={show_product_desc}
            product={selected_item}
            instalmentSchedule={
              instalmentSchedules[selected_item.id] || []
            }
            instalmentSelections={instalmentSelections[selected_item.id] || []}
            onInstalmentSelectionChange={(selected) =>
              this.handleInstalmentSelectionChange(selected_item.id, selected)
            }
            onPayNext={
              selected_item.is_instalment_product === "Y"
                ? (selectedNums, selectedTotal) =>
                    this.handlePayInstalment(selected_item, selectedNums, selectedTotal)
                : null
            }
            handleClose={() => {
              this.setState({ show_product_desc: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state.auth, ...state.home };
};
export default connect(mapStateToProps)(withRouter(MyOrders));
